import script from "./MockExamPageDtail.vue?vue&type=script&setup=true&lang=ts"
export * from "./MockExamPageDtail.vue?vue&type=script&setup=true&lang=ts"

import "./MockExamPageDtail.vue?vue&type=style&index=0&id=5e8cd9ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8cd9ea"]])

export default __exports__